module.exports = __webpack_public_path__ + "static/media/neeraj.c9324361.jpg";